const ClickTriTctAnalysis = "Click Tri/Tct Analysis";
const ClickTriTctAnalysisAction = "Click_Tri_Tct_Analysis_Action";

export default ClickTriTctAnalysis;
export { ClickTriTctAnalysis, ClickTriTctAnalysisAction };
